"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _quotaUtils = require("../utils/quotaUtils");

var _Constants = require("../Constants");

var PipelinesBaseRecord = (0, _immutable.Record)({
  dealPipelines: (0, _immutable.OrderedMap)(),
  ticketPipelines: (0, _immutable.OrderedMap)()
}, 'Pipelines');

var PipelinesRecord =
/*#__PURE__*/
function (_PipelinesBaseRecord) {
  (0, _inherits2.default)(PipelinesRecord, _PipelinesBaseRecord);

  function PipelinesRecord() {
    (0, _classCallCheck2.default)(this, PipelinesRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PipelinesRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(PipelinesRecord, [{
    key: "getByType",
    value: function getByType(quotaType) {
      if ((0, _quotaUtils.typeHasPipelines)(quotaType)) {
        if (_Constants.QUOTA_TYPE_GROUP_MAP[quotaType] === _Constants.QUOTA_TYPE_GROUPS.SALES) {
          return this.dealPipelines;
        }

        return this.ticketPipelines;
      }

      return (0, _immutable.OrderedMap)();
    }
  }]);
  return PipelinesRecord;
}(PipelinesBaseRecord);

exports.default = PipelinesRecord;
module.exports = exports.default;